<template>
    <div  ref="overwCom" class="textover">
        <span v-if="widthpd" class="textclass"  @click="handleClickLink" ref="overw">{{text}}</span>
        <Poptip v-if="!widthpd" trigger="hover"  :content="text" placement="right" word-wrap="true" width="300px">
            <div :style="{width:widthxw+'px'}"  @click="handleClickLink" class="popClass">{{text}}</div>
        </Poptip>
    </div>
</template>

<script>
// right-start右下
// right右中
export default {
    name:'overflowx',
    props: {
        text: [String,Number],
    },
    data() {
        return {
           widthpd:true,
           widthxw:100
        }
    },
    methods: {
        handleClickLink (event, new_window = false) {
            this.$emit('click', event);
        }
    },
    mounted() {
        let tabH = this.$refs.overw.offsetWidth;
        let comH = this.$refs.overwCom.offsetWidth;
        this.widthxw=comH
        if(comH<=tabH){
            this.widthpd=false
        }
        
    }
}
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/main-components/overflow.vue